interface ShowcaseDocumentOptions {
  accent: string;
  body: string;
  css?: string;
  eyebrow: string;
  headerContent?: string;
  title: string;
}

export function showcaseDocument({
  accent,
  body,
  css = "",
  eyebrow,
  headerContent = "",
  title,
}: ShowcaseDocumentOptions) {
  return `<!doctype html>
<html lang="en">
<head>
  <style>
    * { box-sizing: border-box; }
    body { margin: 0; background: #f7f7f4; color: #171717; font-family: Inter, ui-sans-serif, system-ui, sans-serif; }
    main { min-height: 720px; padding: 54px; }
    header { max-width: 920px; margin-bottom: 38px; }
    .eyebrow { margin: 0 0 10px; color: ${accent}; font-size: 12px; font-weight: 800; letter-spacing: .12em; text-transform: uppercase; }
    h1 { max-width: 800px; margin: 0; font-size: 48px; letter-spacing: -.055em; line-height: 1.02; }
    h2 { margin: 0 0 12px; font-size: 18px; letter-spacing: -.025em; }
    h3 { margin: 0 0 8px; font-size: 15px; }
    p { margin: 0; color: #666; font-size: 14px; line-height: 1.55; }
    .grid { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 16px; }
    .card { border: 1px solid #deded8; border-radius: 16px; padding: 22px; background: #fff; }
    .accent { border-color: color-mix(in srgb, ${accent} 45%, #deded8); background: color-mix(in srgb, ${accent} 7%, #fff); }
    .label { display: inline-flex; margin-bottom: 14px; border-radius: 999px; padding: 5px 9px; background: #ededE8; color: #555; font-size: 11px; font-weight: 750; }
    .metric { margin: 4px 0; color: #171717; font-size: 31px; font-weight: 750; letter-spacing: -.05em; }
    .arrow { display: grid; place-items: center; color: ${accent}; font-size: 22px; }
    .flow { display: grid; grid-template-columns: 1fr auto 1fr auto 1fr; align-items: stretch; gap: 12px; }
    .stack { display: grid; gap: 16px; }
    .decision { margin-top: 16px; border-left: 4px solid ${accent}; }
    .bars { display: grid; gap: 12px; }
    .bar { display: grid; grid-template-columns: 115px 1fr 36px; align-items: center; gap: 12px; font-size: 13px; }
    .track { height: 9px; overflow: hidden; border-radius: 99px; background: #e7e7e2; }
    .fill { height: 100%; border-radius: inherit; background: ${accent}; }
    ul { margin: 8px 0 0; padding-left: 18px; color: #666; font-size: 13px; line-height: 1.65; }
    @media (max-width: 720px) {
      main { min-width: 700px; padding: 38px; }
      h1 { font-size: 40px; }
    }
    ${css}
  </style>
</head>
<body>
  <main data-artifact-id="showcase-canvas">
    <header data-artifact-id="showcase-heading">
      <p class="eyebrow">${eyebrow}</p>
      <h1>${title}</h1>
      ${headerContent}
    </header>
    ${body}
  </main>
</body>
</html>`;
}
